export const PageLinks = {
    news_videos: "about/latest-property-news-and-videos",
    tlc_vip: "about/tlc-vip",
    office_url: "contact/office",
    career_url: "about/careers",
    team_url: "about/meet-the-team",
}